// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyABxixHYC8kH0n-vaK-6SgdwNdyJ4MXMTk",
  authDomain: "white-curve.firebaseapp.com",
  projectId: "white-curve",
  storageBucket: "white-curve.firebasestorage.app",
  messagingSenderId: "329547306981",
  appId: "1:329547306981:web:64badd56d6d2818820810c",
  measurementId: "G-7F9ZF5KQVM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);